import React from 'react';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { bool, func, string } from 'prop-types';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@hmhco/loading-button';
import useStyles from './CreateUserButton.styles';
import {
  getEarlyAccessCreateUserStep,
  getEarlyAccessCreateUserIsLoading,
} from '../../../../store/selectors/EarlyAccessCreateUserState';

const CreateUserButton = ({
  isDisabled,
  onClick,
  type = 'submit',
  labelId = 'earlyAccess.createUser.button.submit',
  onBack,
}) => {
  const { classes } = useStyles();
  const earlyAccessStep = useSelector(getEarlyAccessCreateUserStep);
  const isLoading = useSelector(getEarlyAccessCreateUserIsLoading);

  return (
    <div className={classes.buttonContainer}>
      {earlyAccessStep === 2 && (
        <Button onClick={onBack} variant="outlined" color="primary">
          <FormattedMessage id="earlyAccess.createUser.button.back" />
        </Button>
      )}
      <LoadingButton
        loading={isLoading}
        loadingText={
          <FormattedMessage id="earlyAccess.createUser.button.loading" />
        }
        disabled={isDisabled}
        buttonProps={{
          'data-testid': 'createUserSubmitButton',
          variant: 'contained',
          color: 'primary',
          size: 'medium',
          type,
          onClick,
          className: classes.nextButton,
          children: <FormattedMessage id={labelId} />,
        }}
      />
    </div>
  );
};

CreateUserButton.propTypes = {
  isDisabled: bool.isRequired,
  onClick: func,
  type: string,
  labelId: string,
  onBack: func,
};

export default CreateUserButton;
